<template>
  <div class="page-container fee-rate-whitelist">
    <el-card class="page-content" shadow="never">
      <el-form :inline="true" :model="query" size="mini" class="search-form">
        <el-form-item label="名称">
          <el-input v-model.trim="query.name" clearable placeholder="请输入名称" />
        </el-form-item>
        <el-form-item label="业务类型">
          <el-select v-model="query.businessType" clearable placeholder="全部">
            <el-option label="现货" :value="1" />
            <el-option label="合约" :value="2" />
          </el-select>
        </el-form-item>
        <el-form-item label="使用范围">
          <el-select v-model="query.targetType" clearable placeholder="全部">
            <el-option label="指定用户" :value="1" />
            <el-option label="指定合伙人" :value="2" />
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="query.status" clearable placeholder="全部">
            <el-option label="生效中" :value="1" />
            <el-option label="已停用" :value="2" />
          </el-select>
        </el-form-item>
        <el-form-item label="创建人">
          <el-input v-model.trim="query.createdBy" clearable placeholder="精确查询" />
        </el-form-item>
        <el-form-item label="创建时间">
          <el-date-picker v-model="createdRange" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss"
            range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间" />
        </el-form-item>
        <el-form-item label="更新时间">
          <el-date-picker v-model="updatedRange" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss"
            range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search">查询</el-button>
          <el-button @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
      <div class="toolbar">
        <el-button size="mini" type="primary" @click="openCreate">
          新建手续费费率配置
        </el-button>
      </div>
      <el-table :data="list" border>
        <el-table-column prop="id" label="ID" min-width="165" />
        <el-table-column prop="name" label="系数名称" min-width="140" />
        <el-table-column prop="targetTypeName" label="用户范围" width="110" />
        <el-table-column label="业务类型" width="120">
          <template slot-scope="s">
            {{
              businessText(s.row.businessTypes)
            }}
          </template>
        </el-table-column>
        <el-table-column prop="symbolScopeName" label="适用范围" width="110" />
        <el-table-column label="Maker费率" width="120">
          <template slot-scope="s">{{ rateText(s.row, "maker") }}</template>
        </el-table-column>
        <el-table-column label="Taker费率" width="120">
          <template slot-scope="s">{{ rateText(s.row, "taker") }}</template>
        </el-table-column>
        <el-table-column prop="statusName" label="状态" width="90" />
        <el-table-column prop="createdBy" label="创建人" width="110" />
        <el-table-column label="创建时间" width="170">
          <template slot-scope="scope">
            {{ formatUtcToBeijing(scope.row.createdTime) }}
          </template>
        </el-table-column>
        <el-table-column label="更新时间" width="170">
          <template slot-scope="scope">
            {{ formatUtcToBeijing(scope.row.updatedTime) }}
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="230">
          <template slot-scope="s">
            <el-button type="text" size="mini" @click="openDetail(s.row)">详情</el-button>
            <el-button type="text" size="mini" @click="toggle(s.row)">
              {{ s.row.status === 1 ? "停用" : "启用" }}
            </el-button>
            <el-button type="text" size="mini" @click="copy(s.row)">复制</el-button>
            <el-button type="text" size="mini" @click="remove(s.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination :size="pagination.size" :total="total" :page="pagination.page" @pageChanged="pageChanged" />

      <el-dialog :title="dialogMode === 'detail'
        ? '手续费费率配置详情'
        : copying
          ? '复制手续费费率配置'
          : '新建手续费费率配置'
        " :visible.sync="dialogVisible" width="720px" :close-on-click-modal="false" @closed="clearDialog">
        <el-form ref="form" :model="form" :rules="rules" label-width="140px" :disabled="dialogMode === 'detail'">
          <el-form-item label="名称" prop="name">
            <el-input v-model.trim="form.name" maxlength="50" show-word-limit />
          </el-form-item>
          <el-form-item label="用户范围" prop="targetType">
            <el-radio-group v-model="form.targetType" @change="handleTargetTypeChange">
              <el-radio :label="1">指定用户</el-radio>
              <el-radio :label="2">指定合伙人</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item :label="form.targetType === 1 ? '指定用户' : '指定合伙人'" prop="targetInput">
            <el-input v-model.trim="form.targetInput" :placeholder="form.targetType === 1
              ? '多个UID用英文逗号隔开'
              : '请输入顶级合伙人ID'
              " />
          </el-form-item>
          <el-form-item label="业务类型" prop="businessTypes">
            <el-checkbox-group v-model="form.businessTypes" @change="businessChanged">
              <el-checkbox :label="1">现货</el-checkbox>
              <el-checkbox :label="2">合约</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="使用范围" prop="symbolScope">
            <el-radio-group v-model="form.symbolScope">
              <el-radio :label="1">全部交易对</el-radio>
              <el-radio :label="2">指定交易对</el-radio>
            </el-radio-group>
          </el-form-item>
          <template v-if="form.symbolScope === 2">
            <el-form-item v-if="form.businessTypes.indexOf(1) > -1" label="现货交易对" prop="spotSymbolIds">
              <el-select v-model="form.spotSymbolIds" multiple filterable class="symbol-select">
                <el-option v-for="i in spotSymbols" :key="String(i.id)" :label="i.symbol || i.name || i.id"
                  :value="String(i.id)" />
              </el-select>
            </el-form-item>
            <el-form-item v-if="form.businessTypes.indexOf(2) > -1" label="合约交易对" prop="contractSymbolIds">
              <el-select v-model="form.contractSymbolIds" multiple filterable class="symbol-select">
                <el-option v-for="i in contractSymbols" :key="String(i.id)" :label="i.symbol || i.name || i.id"
                  :value="String(i.id)" />
              </el-select>
            </el-form-item>
          </template>
          <el-form-item label="配置方式" prop="configMode">
            <el-radio-group v-model="form.configMode">
              <el-radio :label="1">费率系数</el-radio>
              <el-radio :label="2">按具体手续费费率值</el-radio>
            </el-radio-group>
          </el-form-item>
          <template v-if="form.configMode === 1">
            <el-form-item label="Maker费率系数" prop="makerValue">
              <el-input v-model.trim="form.makerValue">
                <template slot="append">%</template>
              </el-input>
            </el-form-item>
            <el-form-item label="Taker费率系数" prop="takerValue">
              <el-input v-model.trim="form.takerValue">
                <template slot="append">%</template>
              </el-input>
            </el-form-item>
          </template>
          <template v-else>
            <el-form-item label="Maker手续费费率值" prop="makerValue">
              <el-input v-model.trim="form.makerValue">
                <template slot="append">%</template>
              </el-input>
            </el-form-item>
            <el-form-item label="Taker手续费费率值" prop="takerValue">
              <el-input v-model.trim="form.takerValue">
                <template slot="append">%</template>
              </el-input>
            </el-form-item>
          </template>
          <template v-if="dialogMode === 'detail'">
            <el-form-item label="创建人">{{ detail.createdBy || "-" }}</el-form-item>
            <el-form-item label="创建时间">
              {{ formatUtcToBeijing(detail.createdTime) }}
            </el-form-item>
            <el-form-item label="最后操作人">{{ detail.updatedBy || "-" }}</el-form-item>
            <el-form-item label="更新时间">
              {{ formatUtcToBeijing(detail.updatedTime) }}
            </el-form-item>
          </template>
        </el-form>
        <div slot="footer">
          <el-button @click="dialogVisible = false">
            {{ dialogMode === "detail" ? "关闭" : "取消" }}
          </el-button>
          <el-button v-if="dialogMode !== 'detail'" type="primary" :loading="submitting" @click="submit">
            提交
          </el-button>
        </div>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import moment from "moment";
import Pagination from "components/pagination";
import api from "./api";

const emptyForm = () => ({
  name: "",
  targetType: 1,
  targetInput: "",
  targetIds: [],
  businessTypes: [],
  symbolScope: 1,
  spotSymbolIds: [],
  contractSymbolIds: [],
  configMode: 1,
  makerValue: "",
  takerValue: "",
});
export default {
  components: { Pagination },
  data() {
    const targetValidator = (r, v, cb) =>
      this.parseTargets().length ? cb() : cb(new Error("请输入配置对象"));
    const rateValidator = (r, v, cb) => {
      const scale = this.form.configMode === 1 ? 2 : 6;
      const pattern = new RegExp(`^\\d+(?:\\.\\d{1,${scale}})?$`);
      return pattern.test(v)
        ? cb()
        : cb(new Error(`请输入大于等于0且最多${scale}位小数的数值`));
    };
    return {
      query: {
        name: "",
        businessType: "",
        targetType: "",
        status: "",
        createdBy: "",
      },
      createdRange: [],
      updatedRange: [],
      list: [],
      total: 0,
      pagination: { page: 1, size: 20 },
      dialogVisible: false,
      dialogMode: "create",
      copying: false,
      submitting: false,
      detail: {},
      form: emptyForm(),
      spotSymbols: [],
      contractSymbols: [],
      rules: {
        name: [{ required: true, message: "请输入系数名称", trigger: "blur" }],
        targetType: [{ required: true }],
        targetInput: [{ validator: targetValidator, trigger: "blur" }],
        businessTypes: [
          {
            type: "array",
            required: true,
            min: 1,
            message: "请选择业务类型",
            trigger: "change",
          },
        ],
        symbolScope: [{ required: true }],
        configMode: [{ required: true }],
        makerValue: [{ validator: rateValidator, trigger: "blur" }],
        takerValue: [{ validator: rateValidator, trigger: "blur" }],
      },
    };
  },
  mounted() {
    this.load();
    this.loadSymbols();
  },
  methods: {
    /** 详情/列表时间：UTC 数组 [y,M,d,h,m,s] 或字符串 → 北京时间 */
    formatUtcToBeijing(value) {
      if (value === null || value === undefined || value === "") return "-";
      let m;
      if (Array.isArray(value) && value.length >= 3) {
        const [y, month, d, h = 0, min = 0, s = 0] = value;
        // Jackson LocalDateTime：月份 1–12
        m = moment.utc([y, month - 1, d, h, min, Math.floor(s)]);
      } else {
        m = moment.utc(value);
      }
      if (!m.isValid()) return "-";
      return m.utcOffset(8).format("YYYY-MM-DD HH:mm:ss");
    },
    /** 查询入参：北京时间字符串 → UTC */
    beijingToUtc(value) {
      if (!value) return "";
      const m = moment(value, "YYYY-MM-DD HH:mm:ss").utcOffset(8, true);
      if (!m.isValid()) return "";
      return m.utc().format("YYYY-MM-DD HH:mm:ss");
    },
    params() {
      const p = {
        ...this.query,
        page: this.pagination.page,
        size: this.pagination.size,
      };
      ["businessType", "targetType", "status"].forEach((k) => {
        if (p[k] === "") delete p[k];
      });
      if (this.createdRange && this.createdRange.length) {
        p.createdStartTime = this.beijingToUtc(this.createdRange[0]);
        p.createdEndTime = this.beijingToUtc(this.createdRange[1]);
      }
      if (this.updatedRange && this.updatedRange.length) {
        p.updatedStartTime = this.beijingToUtc(this.updatedRange[0]);
        p.updatedEndTime = this.beijingToUtc(this.updatedRange[1]);
      }
      return p;
    },
    load() {
      api.page(this.params()).then((r) => {
        this.list = (r.data && r.data.list) || [];
        this.total = (r.data && r.data.totalCount) || 0;
      });
    },
    search() {
      this.pagination.page = 1;
      this.load();
    },
    reset() {
      this.query = {
        name: "",
        businessType: "",
        targetType: "",
        status: "",
        createdBy: "",
      };
      this.createdRange = [];
      this.updatedRange = [];
      this.search();
    },
    pageChanged(p) {
      this.pagination = p;
      this.load();
    },
    loadSymbols() {
      Promise.all([api.symbols(1), api.symbols(2)])
        .then(([a, b]) => {
          this.spotSymbols = (a && a.data) || [];
          this.contractSymbols = (b && b.data) || [];
        })
        .catch(() => { });
    },
    businessText(v) {
      return (v || []).map((i) => (i === 1 ? "现货" : "合约")).join("/") || "-";
    },
    rateText(row, side) {
      let key =
        row.configMode === 1
          ? `${side}CoefficientPercent`
          : `${side}FeeRatePercent`;
      return row[key] === null || row[key] === undefined ? "-" : `${row[key]}%`;
    },
    openCreate() {
      this.form = emptyForm();
      this.dialogMode = "create";
      this.copying = false;
      this.dialogVisible = true;
    },
    fill(d) {
      this.detail = d;
      this.form = {
        name: d.name || "",
        targetType: d.targetType || 1,
        targetInput: (d.targetIds || []).join(","),
        targetIds: d.targetIds || [],
        businessTypes: (d.businessTypes || []).slice(),
        symbolScope: d.symbolScope || 1,
        spotSymbolIds: (d.symbols || [])
          .filter((i) => i.businessType === 1)
          .map((i) => String(i.symbolId)),
        contractSymbolIds: (d.symbols || [])
          .filter((i) => i.businessType === 2)
          .map((i) => String(i.symbolId)),
        configMode: d.configMode || 1,
        makerValue: String(
          d.configMode === 1 ? d.makerCoefficientPercent : d.makerFeeRatePercent
        ),
        takerValue: String(
          d.configMode === 1 ? d.takerCoefficientPercent : d.takerFeeRatePercent
        ),
      };
    },
    openDetail(row) {
      api.detail(row.id).then((r) => {
        this.fill(r.data);
        this.dialogMode = "detail";
        this.copying = false;
        this.dialogVisible = true;
      });
    },
    copy(row) {
      api.detail(row.id).then((r) => {
        this.fill(r.data);
        this.dialogMode = "create";
        this.copying = true;
        this.dialogVisible = true;
      });
    },
    clearDialog() {
      this.$refs.form && this.$refs.form.clearValidate();
      this.detail = {};
    },
    handleTargetTypeChange() {
      this.form.targetInput = "";
      this.form.targetIds = [];
    },
    parseTargets() {
      return (this.form.targetInput || "")
        .split(",")
        .map((i) => i.trim())
        .filter(Boolean)
        .filter((v, i, a) => a.indexOf(v) === i);
    },
    businessChanged(v) {
      if (v.indexOf(1) < 0) this.form.spotSymbolIds = [];
      if (v.indexOf(2) < 0) this.form.contractSymbolIds = [];
    },
    payload() {
      const f = this.form;
      const data = {
        name: f.name.trim(),
        targetType: f.targetType,
        targetIds: this.parseTargets(),
        businessTypes: f.businessTypes.slice().sort(),
        symbolScope: f.symbolScope,
        symbols: [],
        configMode: f.configMode,
      };
      if (f.targetType === 2) data.targetIds = data.targetIds.slice(0, 1);
      if (f.symbolScope === 2) {
        if (f.businessTypes.indexOf(1) > -1)
          data.symbols.push({ businessType: 1, symbolIds: f.spotSymbolIds });
        if (f.businessTypes.indexOf(2) > -1)
          data.symbols.push({
            businessType: 2,
            symbolIds: f.contractSymbolIds,
          });
      }
      if (f.configMode === 1) {
        data.makerCoefficientPercent = f.makerValue * 1;
        data.takerCoefficientPercent = f.takerValue * 1;
      } else {
        data.makerFeeRatePercent = f.makerValue * 1;
        data.takerFeeRatePercent = f.takerValue * 1;
      }
      return data;
    },
    submit() {
      this.$refs.form.validate((ok) => {
        if (!ok) return;
        if (this.form.targetType === 2 && this.parseTargets().length !== 1)
          return this.$message.error("顶级合伙人必须且只能填写一个");
        if (
          this.form.symbolScope === 2 &&
          ((this.form.businessTypes.indexOf(1) > -1 &&
            !this.form.spotSymbolIds.length) ||
            (this.form.businessTypes.indexOf(2) > -1 &&
              !this.form.contractSymbolIds.length))
        )
          return this.$message.error("请选择对应业务类型的交易对");
        this.submitting = true;
        api
          .create(this.payload())
          .then(() => {
            this.$message.success("提交成功");
            this.dialogVisible = false;
            this.search();
          })
          .finally(() => {
            this.submitting = false;
          });
      });
    },
    toggle(row) {
      const enabling = row.status === 2;
      this.$confirm(`确认${enabling ? "启用" : "停用"}该配置吗？`, "提示", {
        type: "warning",
      })
        .then(() =>
          api[enabling ? "enable" : "disable"]({
            id: row.id,
            version: row.version,
          })
        )
        .then(() => {
          this.$message.success(`${enabling ? "启用" : "停用"}成功`);
          this.load();
        })
        .catch(() => { });
    },
    remove(row) {
      if (row.status === 1)
        return this.$message.warning("请先停用该手续费配置再删除");
      this.$confirm("删除后该目标可重新创建配置，确认删除吗？", "提示", {
        type: "warning",
      })
        .then(() => api.remove({ id: row.id, version: row.version }))
        .then(() => {
          this.$message.success("删除成功");
          this.load();
        })
        .catch(() => { });
    },
  },
};
</script>

<style lang="less" scoped>
.search-form .el-input,
.search-form .el-select {
  width: 180px;
}

.toolbar {
  margin: 0 0 16px;
  text-align: right;
}

.symbol-select {
  width: 100%;
}

.fee-rate-whitelist /deep/ .el-dialog__body {
  max-height: 65vh;
  overflow: auto;
}
</style>
